import React from 'react';
import { Container } from 'reactstrap';

import LoginForm from './login-form';
import { WelcomeMessage } from './WelcomeMessage';

export const HomeAuthPage = () => {
    return (
        <Container fluid="xl" className='minvh-100 px-0 px-md-3'>
            <div className="d-flex align-items-stretch justify-content-center minvh-100">
                <WelcomeMessage />

                <div className="col-login p-md-4 align-self-center d-none d-md-block">
                    <div className='bg-white p-4 col-login-form d-flex flex-column h-100'>
                        <LoginForm />
                    </div>
                </div>
            </div>
        </Container>
    )
}
